// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3k3QM","clinicsSelect":"TableHeading_clinicsSelect__3w_6H"};